import { cn } from '@/lib/utils'
import { useTile } from '../../context'
import TileWrapper from '../TileWrapper'
import { ExternalLink } from 'lucide-react'

interface CustomLink {
  label: string
  url: string
}

const CustomLinksTile = () => {
  const { tile } = useTile()
  const links = (tile.config?.links as CustomLink[]) || []

  if (links.length === 0) {
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No links configured.</p>
      </TileWrapper>
    )
  }

  const isSidebar = tile.position === 'sidebar'

  return (
    <TileWrapper>
      <ul className={isSidebar ? 'space-y-1' : 'flex gap-4'}>
        {links.map((link, index) => (
          <li
            key={index}
            className={
              isSidebar
                ? ''
                : 'flex-1 bg-background rounded-md p-2 flex w-full items-center justify-center'
            }
          >
            <a
              href={link.url}
              target='_blank'
              rel='noopener noreferrer'
              className={cn(
                isSidebar ? 'inline-flex' : 'flex w-full h-full justify-center',
                'items-center gap-2 hover:text-primary break-all transition-colors',
              )}
            >
              <ExternalLink className='h-3 w-3 min-h-3 min-w-3' />
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </TileWrapper>
  )
}

export default CustomLinksTile
